import { render } from "./RemoteDicomDeviceList.vue?vue&type=template&id=3b616bd4&scoped=true"
import script from "./RemoteDicomDeviceList.vue?vue&type=script&lang=js"
export * from "./RemoteDicomDeviceList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b616bd4"]])

export default __exports__